var map = {
	"../pages/ajustes/ajustes.module": [
		329,
		2
	],
	"../pages/cuadrillas/cuadrillas.module": [
		330,
		1
	],
	"../pages/fichada-detalle/fichada-detalle.module": [
		331,
		4
	],
	"../pages/fichada-edit/fichada-edit.module": [
		332,
		3
	],
	"../pages/fichadas/fichadas.module": [
		333,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 163;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 163
// module chunks = 5